import { render } from "./OfferBoxes.vue?vue&type=template&id=b1e1eb5c"
import script from "./OfferBoxes.vue?vue&type=script&lang=js"
export * from "./OfferBoxes.vue?vue&type=script&lang=js"

import "./OfferBoxes.vue?vue&type=style&index=0&id=b1e1eb5c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__